interface Props {
  error: {
    message: string;
  };
}

function ErrorMessage({ error }: Props) {
  return !error ? null : (
    // TODO: style error message
    <div>{error.message}</div>
  );
}

export default ErrorMessage;
